/* Toggle between layouts */

document.querySelectorAll('.blog-facets__layout button').forEach((button) => {
  button.addEventListener('click', (event) => {
    var newLayout = event.currentTarget.value;
    document.querySelector('.blog-articles')?.setAttribute('data-layout', newLayout);
    setActiveButton();
  });
});

function setActiveButton() {
  var currentLayout = document.querySelector('.blog-articles')?.getAttribute('data-layout');
  document.querySelectorAll('.blog-facets__layout button').forEach((button) => {
    if (button.value === currentLayout) {
      button.classList.add('active');
    } else {
      button.classList.remove('active');
    }
  });
}

setActiveButton();

/* custom dropdown */

var dropdown = document.getElementById('tags');
var tagValue = /[^/]*$/.exec(window.location.href)[0]; /* Get string after last slash */
var destination;

/* Set dropdown value to current page */
if (tagValue === "news") {
  var destination = "/blogs/news";
} else {
  var destination = "/blogs/news/tagged/" + tagValue;
}
dropdown.value = destination;

var x, i, j, l, ll, selElmnt, a, b, c;
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName("news-select");
l = x.length;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement("div");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement("div");
  b.setAttribute("class", "select-items select-hide");
  for (j = 1; j < ll; j++) {
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    c = document.createElement("div");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener("click", function(e) {
        window.location.href = "/blogs/news/tagged/" + this.innerHTML;
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function(e) {
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
  });
}

function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x, y, i, xl, yl, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", closeAllSelect);